import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Multimedia/Audio/SuccessBox';
import AudioTable from 'components/Web_User_Interface/1080p_Series/Multimedia/Audio/audioTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  AudioTable,
  BreadCrumbs,
  SEOHelmet,
  React
};